export const actionTypes = {
  setAttemptingWord: "setAttemptingWord"
};

export function setAttemptingWord(attempting: string | null | undefined) {
  return {
    type: actionTypes.setAttemptingWord,
    payload: attempting
  };
}
